/**
 * Returns DocumentViewer of this document
 * An instance of DocumentViewer is added to window in src/index.js
 */
export default () => window.documentViewer;